import React from 'react';
import PictureIcon from './PictureIcon';
import VideoIcon from './VideoIcon';
import { priceFormat } from '../../../../../Util';
import Button from 'react-bootstrap/Button';

function ResultTableRow(props){
  const { cartDiamond, onDelete } = props;

  const isFancy = cartDiamond['fancy'];
  return (
    <tr className="result-table-rowresult-table-row-closed">
      <td>{cartDiamond['stockIdNumber']}</td>
      <td>{cartDiamond['shape']}</td>
      <td>{cartDiamond['weight']}</td>
      <td>{isFancy ? cartDiamond['fancyColor'] : cartDiamond['color']}</td>
      <td>{cartDiamond['clarity']}</td>
      <td>{cartDiamond['lab']}</td>
      <td>{cartDiamond['cutGrade']}</td>
      <td>{cartDiamond['polish']}</td>
      <td>{cartDiamond['symmetry']}</td>
      <td>{cartDiamond['fluorescenceIntensity']}</td>
      <td>{parseFloat(cartDiamond['depthPercent']).toFixed(1)}%</td>
      <td>{parseFloat(cartDiamond['tablePercent']).toFixed(1)}%</td>
      <td>{cartDiamond['length']}x{cartDiamond['width']}x{cartDiamond['depth']}</td>
      <td>{parseFloat(cartDiamond['ratio']).toFixed(2)}:1</td>
      <td align="right">${priceFormat(cartDiamond['ctPrice'])}</td>
      <td align="right">${priceFormat(cartDiamond['price'])}</td>
      <td align="right">
        {
          cartDiamond['rappaportDiscountPercent'] ?
          parseFloat(cartDiamond['rappaportDiscountPercent']).toFixed(1) + '%' :
          'n/a'
        }
      </td>
      <td>{cartDiamond['status']}</td>
      <td className="center text-center">{cartDiamond['imageUrlList'] ? <PictureIcon /> : null }</td>
      <td className="center text-center">{cartDiamond['videoUrlList'] ? <VideoIcon /> : null }</td>
      <td className="center text-center">
        <Button
          className="py-0"
          variant="outline-danger"
          size="sm"
          title="remove item from cart"
          onClick={() => onDelete(cartDiamond)}
        >remove</Button>
      </td>
    </tr>
  );
}

export default ResultTableRow;
